/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, InputGroup, Row } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { Button, Input, Table } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllSoldOrderList } from "../../redux/Slice/Pos/SoldOrderListSlice";
import { toast } from "react-toastify";

const SoldProductList = (props: any) => {
  const { HandleDownload, facilityId } = props;
  const dispatch = useAppDispatch();
  const { SoldProductData, currentPage, rowsPerPage, totalPage, totalRows, errorMessage } =
    useAppSelector((state) => state.SoldOrderList);
  const [key, setKey] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const SoldListHeader = [
    "Sr No",
    "Product",
    "Customer Name",
    "Contact No",
    "Date",
    "Qty",
    "Price Per Unit",
    "Total Paid Amount",
  ];
  const SoldListAccessor = [
    "srNo",
    "name",
    "customerName",
    "phone",
    "createdAt",
    "quantity",
    "sellingPrice",
    "totalAmount",
  ];

  const column = SoldListHeader.map((_, index) => ({
    Header: SoldListHeader[index],
    accessor: SoldListAccessor[index],
  }));

  const convertDate = (date: string) =>
    date?.split("-").reverse().join("-")
      ? date?.split("-").reverse().join("-")
      : "";

  useEffect(() => {
    if (key.length <= 0)
      dispatch(
        AllSoldOrderList({
          page: "1",
          facilityId: facilityId,
          key: "",
          fromDate: convertDate(fromDate),
          toDate: convertDate(toDate),
        })
      );
  }, [key]);

  const handleDownload = (id: any) => {
    let selectSoldProduct = SoldProductData.find((item) => item.id == id);
    HandleDownload(selectSoldProduct?.hash, id);
  };

  const NextPage = (nextpage: number) => {
    dispatch(
      AllSoldOrderList({
        page: nextpage,
        facilityId: facilityId,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
      })
    );
  };

  const PreviousPage = (prevpage: number) => {
    dispatch(
      AllSoldOrderList({
        page: prevpage,
        facilityId: facilityId,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
      })
    );
  };

  const handleSearch = () => {
    dispatch(
      AllSoldOrderList({
        page: "1",
        facilityId: facilityId,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
      })
    );
  };

  const handleFromDate = (e: any) => {
    setFromDate(e?.format("DD-MM-YYYY"));
  };

  const handleToDate = (e: any) => {
    setToDate(e?.format("DD-MM-YYYY"));
  };

  const handleSearchByDate = () => {
    dispatch(
      AllSoldOrderList({
        page: "1",
        facilityId: facilityId,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
      })
    );
  };

  const handleClear = () => {
    setKey("");
    setFromDate("");
    setToDate("");
    dispatch(
      AllSoldOrderList({
        page: "1",
        facilityId: facilityId,
        key: "",
        fromDate: "",
        toDate: "",
      })
    );
  };

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Sales Product List</Card.Title>
          </div>
          <Row className="row-mb">
            <Col lg={3}>
              <div className="text-start">
                <InputGroup>
                  <Input
                    value={key}
                    type="text"
                    id="search-booking"
                    name="search-booking"
                    className="form-control form-control-sm h-auto"
                    placeholder="Search . . ."
                    onChange={(e: any) => setKey(e.target.value)}
                  />
                  <Button
                    disabled={key.length < 3}
                    onClick={handleSearch}
                    type="button"
                    bname="Search"
                    name="search-button"
                    id="search-button"
                    className="btn btn-primary btn-sm rounded-1"
                  />
                </InputGroup>
                {key.length && key.length < 3 ? (
                  <span className="error-msg">
                    Minimum 3 characters required
                  </span>
                ) : key.length >= 3 ? (
                  <span className="error-msg text-wrap w-25">
                    Search by Product Name or First Name or Last Name
                  </span>
                ) : (
                  ""
                )}
              </div>
            </Col>
            <Col lg={4}>
              <label className="form-label me-1"> Start Date : </label>
              <DatePicker
                format="DD-MM-YYYY"
                value={fromDate}
                onChange={handleFromDate}
                render={
                  <InputIcon className="form-control form-control-sm h-auto" />
                }
              />
            </Col>
            <Col lg={4} className="position-relative">
              <InputGroup className="align-items-center">
                <label className="form-label me-1"> End Date : </label>
                <DatePicker
                  format="DD-MM-YYYY"
                  value={toDate}
                  onChange={handleToDate}
                  render={
                    <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                  }
                  minDate={new Date(fromDate?.split("-").reverse().join("-"))}
                />
                <Button
                  onClick={handleSearchByDate}
                  type="button"
                  bname="Go"
                  name="Go-button"
                  id="go-button"
                  className="btn btn-primary btn-sm rounded-1"
                />
              </InputGroup>
              {fromDate || toDate || key ? (
                <div
                  onClick={handleClear}
                  className="btn btn-link position-absolute top-0"
                  style={{ cursor: "pointer", left: "90%" }}
                >
                  Clear
                </div>
              ) : (
                ""
              )}
            </Col>
            <Col lg={1}></Col>
          </Row>
        </Card.Body>
        <div className="table-responsive">
          <Table
            columns={column}
            data={SoldProductData}
            hideEditAction={true}
            hideViewAction={true}
            hideDeleteAction={true}
            hideDownloadAction={false}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalPage={totalPage}
            totalRows={totalRows}
            NextPage={NextPage}
            PreviousPage={PreviousPage}
            show={true}
            isSorting={true}
            HandleDownload={handleDownload}
          />
        </div>
      </Card>
    </>
  );
};

export { SoldProductList };
